export default __webpack_public_path__ + "static/media/leadership-summit-2024.25165c80.jpg";